import { useLocation } from "react-router-dom"
import { useSelector } from "react-redux";
import { select_director } from "../../stores/authSlice";
import { Link } from "react-router-dom";
import clsx from "clsx";

export default function Navigation() {
    const { pathname } = useLocation();
    const isDirector = useSelector(select_director);

    return (
        <nav className="w-full h-screen lg:w-auto lg:h-auto -z-10 flex flex-col justify-between bg-dark-three absolute lg:static top-0 -right-full pt-20 lg:pt-0 transition-all duration-300 peer-[:has(:checked)]:right-0 lg:bg-transparent">
            <ul className="flex flex-col lg:flex-row gap-8 lg:gap-4 p-4 lg:p-6 lg:px-0 mt-12 lg:mt-0">
                <NavLink name={"homepage"} href={"/"} path={pathname}/>
                <NavLink name={"play"} href={"/play"} path={pathname}/>
                <NavLink name={"emblem builder"} href={"/builder"} path={pathname}/>
                <NavLink name={"guardian"} href={"/guardian"} path={pathname}/>
                {isDirector &&  <NavLink  name={"creator"} href={"/creator"} path={pathname}/>}
            </ul>
        </nav>
    )
}

const NavLink = ({
    name,
    href,
    path
}) => {
    return (
        <li key={name}>
            <Link
                to={href}
                className={clsx(
                    "w-full px-5 py-2 rounded-full lg:transition-colors lg:duration-300 lg:hover:bg-epic-blue-back lg:hover:text-epic-blue text-3xl lg:text-sm",
                    {
                        "text-white-main lg:text-epic-blue lg:bg-epic-blue-back": href === path,
                        "text-dark-back lg:text-white-main": href !== path
                    }
                )}
            >{name}</Link>
        </li>
    )
}